<app-pageheader Title="Notification Policies">
  <app-form-save-button [Parent]="Busyable" (OnSave)="OnSave()" [Form]="this"></app-form-save-button>
</app-pageheader>

<app-loader *ngIf="loading" [AlwaysOn]="true"></app-loader>

<div class="policy-list" *ngIf="!loading">
  <div class="box policy-category" *ngFor="let category of categories">
    <div class="policy-row policy-category-row">
      <div>
        <h2 class="title is-5 mb-1">{{ category.CategoryName }}</h2>
        <p class="help mb-0">
          {{ category.HasPolicy ? 'Category policy is active' : 'No category policy. Templates are allowed unless individually overridden.' }}
        </p>
      </div>
      <div class="policy-channels">
        <label class="checkbox">
          <input type="checkbox" [checked]="category.BlockEmail" (change)="setCategoryChannel(category, 1, $any($event.target).checked)">
          Block all email
        </label>
        <label class="checkbox">
          <input type="checkbox" [checked]="category.BlockSms" (change)="setCategoryChannel(category, 2, $any($event.target).checked)">
          Block all SMS
        </label>
        <label class="checkbox">
          <input type="checkbox" [checked]="category.BlockMobileNotification" (change)="setCategoryChannel(category, 4, $any($event.target).checked)">
          Block all mobile
        </label>
      </div>
    </div>

    <div class="policy-template-list">
      <div class="policy-row policy-template-row" *ngFor="let template of category.Templates">
        <div>
          <div class="has-text-weight-semibold">{{ template.TemplateTypeName }}</div>
          <p class="help mb-0">{{ template.TemplateDescription }}</p>
        </div>
        <div class="policy-channels">
          <label class="checkbox">
            <input type="checkbox" [checked]="template.BlockEmail" (change)="setTemplateChannel(template, 1, $any($event.target).checked)" [disabled]="isCategoryChannelBlocked(template, 1)">
            Block email
          </label>
          <label class="checkbox">
            <input type="checkbox" [checked]="template.BlockSms" (change)="setTemplateChannel(template, 2, $any($event.target).checked)" [disabled]="isCategoryChannelBlocked(template, 2)">
            Block SMS
          </label>
          <label class="checkbox">
            <input type="checkbox" [checked]="template.BlockMobileNotification" (change)="setTemplateChannel(template, 4, $any($event.target).checked)" [disabled]="isCategoryChannelBlocked(template, 4)">
            Block mobile
          </label>
          <button type="button" class="button is-small is-light" (click)="clearTemplateOverride(template)" *ngIf="template.HasPolicy">
            Inherit category
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
